<div class="d-flex flex-column" *ngIf="user$ | async;else loading">
  <div class="d-flex flex-column wrapper">

    <header>
      <app-topnav></app-topnav>
      <!--<app-broadcasts-banner></app-broadcasts-banner>-->
    </header>

    <main class="flex-fill">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>

  </div>
</div>

<ng-template #loading>
  <div class="container d-flex justify-content-center align-items-center vh-100">
    <mat-spinner [diameter]="45"></mat-spinner>
  </div>
</ng-template>
